export const voiceActivityDetectionTimeoutMs = 5000;
